// Types
import type { WithUserWebViewProps } from '@shopee-user/with-web-view';
import { setCurrentUrl } from '@tob/shared/utils/redirection';

type setCurrentUrlFn = typeof setCurrentUrl;

export enum PasswordUseCase {
  AddPassword = 'AddPassword',
  ChangePassword = 'ChangePassword',
}

export type AddOrChangePasswordExitHandling = {
  nonce: string;
  isWebViewLogoutAfterCredentialChangeEnabled: boolean;
  isUserPasswordWebLogoutAfterCredentialChangeEnabled: boolean;
  isShopeePayChangePasswordEnabled: boolean;
  webViewLogoutSuccessfully: WithUserWebViewProps['webViewLogoutSuccessfully'];
  webViewNotifyRefreshTokenAfterChangeCredentials: WithUserWebViewProps['webViewNotifyRefreshTokenAfterChangeCredentials'];
  exitWithSuccess: () => void;
  safelyRedirectToNextUrlFromQueryString: (
    queryObject?: Record<string, string | boolean | number | undefined>
  ) => void;
  setCurrentUrl: setCurrentUrlFn;
  passwordUseCase: PasswordUseCase;
};
